import React from 'react';
import {
  FDTitleText, FDStack, FDPaper, FDIcon, FDBodyText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);

export const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDPaper flex={1} padding={2}>
      <FDStack direction="column" spacing={2}>
        <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
        {resource.attr('details') && resource.attr('details').map((detail) => (
          <FDStack spacing={1}>
            <FDIcon icon={'checkCircleIcon'} />
            <FDBodyText value={detail} />
          </FDStack>
        ))}
      </FDStack>
    </FDPaper>
  );
};
